// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F1a6","rootNoMargin":"styles_rootNoMargin__1W1Gy"};